import { useDispatch, useSelector } from "react-redux";
import { selectTranslations } from "../../services/i18n/i18nSlice";
import { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';

import  Form from 'react-bootstrap/Form';
import  Modal from 'react-bootstrap/Modal';
import { Accordion, Spinner } from "react-bootstrap";
import AccordionButton from 'react-bootstrap/AccordionButton'

import { API_URL } from "../../config/constants";

import close_img from '../../assets/images/close.svg'
import ai_img from '../../assets/images/questions/ai.svg'
import excel_img from '../../assets/images/questions/excel.svg'

import '../../components/_modals/modalStyle.css'
import { fetchAcceptGeneratedQuestion, fetchGenerateQuestion, fetchRegenerateQuestion, fetchRejectGeneratedQuestion } from "../../screens/ExamScreen/ExamApi";
import { Step, Stepper } from "react-form-stepper";
import { setLoading } from "../../services/global/globalSlice";
export default function AiEditor (props) {

    const {show, type, index, onClose, onUpdate, examData, examId} = props
    const dispatch = useDispatch()
    const t = useSelector(selectTranslations)
    const [generationData, setGenerationData] = useState({
        num_questions: 2,
        num_answers: 4,
        num_correct_answers: 1,
        generate_pills: false,
        additional_instruction_prompt: "",
        language: "it",
        generation_id : null,
        generation_confirm : false
    })
    const [generatedQuestions, setGeneratedQuestions] = useState(null)
    const [isUploading, setIsUploading] = useState(false)
    const [hasFile, setHasFile] = useState(false)
    const [hasAdditionalFile, setHasAdditionalFile] = useState(false)
    const [activeStep, setActiveStep] = useState(0)
    const handleContentChange = (e) => {
        const target = e.target
        const name = target.name
        const value = target.type === "checkbox" ? target.checked : target.value
        setGenerationData({
            ...generationData,
            [name] : value
        })
    }

    const uploadRef = useRef()
    const additionalUploadRef = useRef()

    const generateQuestions = async (event) => {
        setIsUploading(true)
        if(generationData.num_questions == 0 && generationData.num_answers <= 1){
            toast.error(t.ai_assistant.errors.missing_request, {
                position: "top-right"
            })
            return;
        }
        setActiveStep(3)

        if (uploadRef.current.files[0]) {
            let reader = new FormData();
            reader.append("file",uploadRef.current.files[0]);
            const _generationData = structuredClone(generationData)
            _generationData["num_questions"] = parseInt(_generationData["num_questions"])
            _generationData["num_answers"] = parseInt(_generationData["num_answers"])
            _generationData["num_correct_answers"] = parseInt(_generationData["num_correct_answers"])
            if( _generationData["module_name"] === "")
                delete _generationData.module_name
            if( _generationData["generation_id"] === null)
                delete _generationData.generation_id          
            if (additionalUploadRef?.current?.files[0])
                reader.append("additional_instruction_file",additionalUploadRef.current.files[0]);
            const response = await fetchGenerateQuestion(examId, _generationData, reader)
            if (response.success) {
                if(response?.data?.generation_id && response?.data?.questions ){
                    toast.success(t.ai_assistant.questions_generated, {
                        position: "top-right"
                    })
                    setGeneratedQuestions(response?.data?.questions)
                    setGenerationData({
                        ...generationData,
                        generation_id: response?.data?.generation_id,
                        new_additional_instruction_prompt: ""
                    })
                    //onUpdate()
                } else{
                    toast.error(t.ai_assistant.errors.error_generating, {
                        position: "top-right"
                    })
                    setActiveStep(2)
                    return;
                }
            } else {
                toast.error(t.ai_assistant.errors.error_generating, {
                    position: "top-right"
                })
                setActiveStep(2)
            }
            setIsUploading(false)
        } else {
            toast.error(t.ai_assistant.errors.missing_file, {
                position: "top-right"
            })
            setIsUploading(false)
            setActiveStep(2)
            return;
        }
    }

    const regenerateQuestions = async (event) => {
        if(generationData?.new_additional_instruction_prompt){
            setIsUploading(true)
            const response = await fetchRegenerateQuestion(generationData?.generation_id, generationData?.new_additional_instruction_prompt)
            if (response.success) {
                if(response?.data?.generation_id && response?.data?.questions ){
                    toast.success(t.ai_assistant.questions_generated, {
                        position: "top-right"
                    })
                    setGeneratedQuestions(response?.data?.questions)
                    setGenerationData({
                        ...generationData,
                        generation_id: response?.data?.generation_id,
                        new_additional_instruction_prompt: ""
                    })
                    //onUpdate()
                } else{
                    toast.error(t.ai_assistant.errors.error_generating, {
                        position: "top-right"
                    })
                    setActiveStep(3)
                    return;
                }
            } else {
                toast.error(t.ai_assistant.errors.error_generating, {
                    position: "top-right"
                })
                setActiveStep(3)
            }
            setIsUploading(false)
        } else {
            toast.error(t.ai_assistant.errors.missing_details, {
                position: "top-right"
            })
        }
        
    }

    const saveQuestions = async () => {
        dispatch(setLoading(true))
        const response = await fetchAcceptGeneratedQuestion(generationData?.generation_id)
        if (response.success) {
            if(response?.data === "ok" ){
                toast.success(t.ai_assistant.questions_added, {
                    position: "top-right"
                })
                onUpdate()
                dispatch(setLoading(false))
            } else{
                toast.error(t.ai_assistant.errors.error_accepting, {
                    position: "top-right"
                })
                setActiveStep(3)
                dispatch(setLoading(false))
                return;
            }
        } else {
            toast.error(t.ai_assistant.errors.error_accepting, {
                position: "top-right"
            })
            setActiveStep(3)
            dispatch(setLoading(false))
        }
    }

    const rejectQuestions = async () => {
        const response = await fetchRejectGeneratedQuestion(generationData?.generation_id)
        if (response.success) {
            if(response?.data === "ok" ){
                toast.success(t.ai_assistant.questions_rejected, {
                    position: "top-right"
                })
                onUpdate()
            } else{
                toast.error(t.ai_assistant.errors.error_accepting, {
                    position: "top-right"
                })
                setActiveStep(3)
                return;
            }
        } else {
            toast.error(t.ai_assistant.errors.error_accepting, {
                position: "top-right"
            })
            setActiveStep(3)
        }
    }

    const checkFiles = () => {
        if(uploadRef.current?.files[0])
            setActiveStep(1)
        else    
            toast.error(t.ai_assistant.errors.missing_file)
    }

    const handleUpload = () => {
        if(uploadRef.current?.files[0])
            setHasFile(true)
    } 
    const handleAdditionalUpload = () => {
        if(additionalUploadRef.current?.files[0])
            setHasAdditionalFile(true)
    } 

    useEffect(()=>{
        setHasFile(false)
        setHasAdditionalFile(false)
        setActiveStep(0)
    },[show])

    return(
        <>
            <Modal
                show={show}
                onHide={onClose}
                centered
                size="lg"
            >
                <Modal.Body
                    style={{borderRadius:"16px"}}
                >
                    <div className="d-flex justify-content-end w-100">
                        <img src={close_img} className="pointer" onClick={onClose} />
                    </div>
                    <h2 className="text-start mb-2" ><img src={ai_img} className="me-1" style={{maxWidth:"35px"}} />{t.question.create_with_ai}</h2>
                    <Stepper 
                        activeStep={activeStep}
                        styleConfig={{
                            activeBgColor: "#436094",
                            completedBgColor: "#436094",
                            inactiveBgColor: "#E2E2E2"
                        }}
                    >
                        <Step label={t.ai_assistant.steps.step_0}  onClick={()=>setActiveStep(0)}/>
                        <Step label={t.ai_assistant.steps.step_1} onClick={()=>setActiveStep(1)}/>
                        <Step label={t.ai_assistant.steps.step_2} onClick={()=>setActiveStep(2)}/>
                        <Step label={t.ai_assistant.steps.step_3} onClick={()=>setActiveStep(3)}/>
                    </Stepper>
                    
                    
                    <div style={{opacity:isUploading || activeStep !== 0 ? '0' : 1, height:isUploading || activeStep !== 0 ? '0' : 'auto', overflow:isUploading || activeStep !== 0 ? 'hidden' : 'visible'}}>
                        <div className="d-flex flex-column align-items-center justify-content-center mt-2">
                            <div>
                                <label htmlFor={`upload_input_ai_editor`} className={"upload_button colored d-flex align-items-center "}>
                                        <img src={ai_img} className="me-1" style={{maxWidth:"35px"}} />
                                        {t.ai_assistant.source_file}
                                </label>
                                <input id={`upload_input_ai_editor`}  type="file" ref={uploadRef} disabled={isUploading} hidden className="w-100 mt-2 standardInput" onChange={handleUpload}/>
                                {
                                    hasFile && <span>{uploadRef.current?.files[0].name}</span>
                                }
                            </div>
                            <div>
                                <label htmlFor={`upload_input_ai_editor_additional`} className={"upload_button colored d-flex align-items-center mt-4"}>
                                        <img src={excel_img} className="me-1" style={{maxWidth:"35px"}} />
                                        {t.ai_assistant.additional_file}
                                </label>
                                <input id={`upload_input_ai_editor_additional`} accept=".xlsx,.xls"  type="file" ref={additionalUploadRef} disabled={isUploading} hidden className="w-100 mt-2 standardInput" onChange={handleAdditionalUpload}/>
                                {
                                    hasAdditionalFile && <span>{additionalUploadRef.current?.files[0].name}</span>
                                }
                            </div>
                        </div>
                        <div className="d-flex justify-content-end mt-3">
                            <button onClick={checkFiles} disabled={!hasFile}>{t.buttons.next}</button>
                        </div>
                    </div>
                    {
                        activeStep === 1 &&
                        <div>
                            <Form.Group controlId="your_instructions" className='w-100 mt-3'>
                                <Form.Label>{t.ai_assistant.your_instructions}*</Form.Label>
                                <Form.Control type="text" as="textarea" value={generationData?.additional_instruction_prompt} name="additional_instruction_prompt" onChange={handleContentChange} />
                            </Form.Group>
                            <Form.Group controlId="module_name" className='w-100 mt-3'>
                                <Form.Label>{t.ai_assistant.module_name}*</Form.Label>
                                <Form.Control type="text"  value={generationData?.module_name} name="module_name" onChange={handleContentChange} />
                            </Form.Group>
                            <div className="d-flex justify-content-between mt-3 align-items-center">
                                <span className="pointer" onClick={()=>{setActiveStep(0)}}>{t.buttons.back}</span>
                                <button onClick={()=>setActiveStep(2)}>{t.buttons.next}</button>
                            </div>
                        </div>
                    }
                    {
                        activeStep === 2 &&
                        <div>
                            <div className="d-flex mt-3">
                                <Form.Group controlId="num_questions" className='w-50'>
                                    <Form.Label>{t.ai_assistant.question_number}*</Form.Label>
                                    <Form.Control type="number" value={generationData?.num_questions} name="num_questions" onChange={handleContentChange} />
                                </Form.Group>
                                <Form.Group controlId="num_answers" className='w-50'>
                                    <Form.Label>{t.ai_assistant.answer_number}*</Form.Label>
                                    <Form.Control type="number" value={generationData?.num_answers} name="num_answers" onChange={handleContentChange} />
                                </Form.Group>
                            </div>
                            <div className="d-flex mt-3">
                                <Form.Group controlId="correct_answer_number" className='w-50'>
                                    <Form.Label>{t.ai_assistant.correct_answer_number}*</Form.Label>
                                    <Form.Control type="number" value={generationData?.num_correct_answers} name="num_correct_answers" onChange={handleContentChange} />
                                </Form.Group>
                                <Form.Check // prettier-ignore
                                    type="switch"
                                    id="ready"
                                    name="generate_pills"
                                    className='mt-2'
                                    label={t.ai_assistant.generate_pill}
                                    onChange={handleContentChange}
                                    checked={generationData.generate_pills}
                                />
                            </div>
                            <div className="d-flex justify-content-between mt-3 align-items-center">
                                <span className="pointer" onClick={()=>{setActiveStep(1)}}>{t.buttons.back}</span>
                                <button onClick={generateQuestions}>{t.ai_assistant.generate_questions}</button>
                            </div>
                        </div>
                    }
                    {
                        (isUploading && activeStep === 3) &&
                            <div className="text-center">
                                <img src={ai_img} className="me-1" style={{maxWidth:"55px"}} />
                                
                                <h2 >{t.ai_assistant.generation_in_progress}</h2>
                                <p>{t.ai_assistant.generation_in_progress_text}</p>
                                <Spinner />
                            </div>
                    }
                    {
                        (!isUploading && activeStep === 3) &&
                            <div id="generated_questions" style={{maxHeight:'500px',overflowY:'scroll'}}>
                                <h3>{t.ai_assistant.generation_result}</h3>
                                <Accordion defaultActiveKey="0">
                                    {
                                        generatedQuestions?.map((question, index)=>{
                                            return(
                                                <Accordion.Item eventKey={index} key={index} className="w-100">
                                                    <AccordionButton style={{maxWidth:'none'}}>{t.question.question} {index+1} <small className="ms-2" style={{fontWeight:500}}>{question.text}</small></AccordionButton>
                                                    <Accordion.Body>
                                                        <p><strong>{t.question.answers}:</strong></p>
                                                        <ol>
                                                            {
                                                                question.answers?.map((answer,index_a)=>{
                                                                    return(
                                                                        <li>{answer.text}</li>
                                                                    )
                                                                })
                                                            }
                                                        </ol>
                                                        {
                                                            question.pill?.text && 
                                                            <>
                                                                <p><strong>{t.question.pill}:</strong></p>
                                                                <p>{question.pill?.text}</p>
                                                            </>
                                                        }
                                                    </Accordion.Body>
                                                </Accordion.Item>
                                            )
                                        })
                                    }
                                    
                                </Accordion>
                                <Form.Group controlId="new_additional_instruction_prompt" className='w-100 mt-3'>
                                    <Form.Label>{t.ai_assistant.additional_feedback}*</Form.Label>
                                    <Form.Control type="text" as="textarea" value={generationData?.new_additional_instruction_prompt} name="new_additional_instruction_prompt" onChange={handleContentChange} />
                                </Form.Group>
                                <p>{t.ai_assistant.disclaimer}</p>
                                {
                                    !generationData?.new_additional_instruction_prompt &&
                                        <Form.Check // prettier-ignore
                                            type="checkbox"
                                            id="generation_confirm"
                                            name="generation_confirm"
                                            className='mt-2'
                                            label={t.ai_assistant.generation_confirm}
                                            onChange={handleContentChange}
                                            checked={generationData.generation_confirm}
                                        />
                                }
                                <div className="d-flex justify-content-between mt-3 align-items-center">
                                    <a href="#" className="text-danger border-danger border-0" onClick={rejectQuestions}>{t.ai_assistant.reject}</a>
                                    <div className="d-flex">
                                        {
                                            generationData?.new_additional_instruction_prompt ?
                                                <button onClick={regenerateQuestions} >{t.ai_assistant.regenerate}</button>
                                            :
                                                <button disabled={!generationData.generation_confirm} className="ms-2" onClick={saveQuestions}>{t.ai_assistant.save}</button>
                                        }
                                    </div>
                                    
                                </div>
                            </div>
                    }
                    
                    
                </Modal.Body>
            </Modal>
        </>
    )
}